import {
  getAssignedCompanies,
  getCompanyUsers,
  getUserCredit as getUserCreditApi,
  submitCreditTransfer as submitCreditTransferApi,
} from "app/api/credit-transfer.api";
import {
  setCompanies, setCompanyUsers, setUserCredit,
  setTransferring, setTransferResult, setLoading, setError,
} from "./credit-transfer.slice";

export const fetchCompanies = () => async (dispatch) => {
  dispatch(setLoading({ key: "isLoadingCompanies", value: true }));
  try {
    const response = await getAssignedCompanies();
    dispatch(setCompanies(response.data.data || []));
  } catch (error) {
    dispatch(setError(error.response?.data?.message || "Failed to fetch companies"));
    dispatch(setLoading({ key: "isLoadingCompanies", value: false }));
  }
};

export const fetchCompanyUsers = (companyUuid) => async (dispatch) => {
  dispatch(setLoading({ key: "isLoadingUsers", value: true }));
  try {
    const response = await getCompanyUsers(companyUuid);
    dispatch(setCompanyUsers(response.data.data || []));
  } catch (error) {
    dispatch(setError(error.response?.data?.message || "Failed to fetch users"));
    dispatch(setLoading({ key: "isLoadingUsers", value: false }));
  }
};

export const fetchUserCredit = (userSub) => async (dispatch) => {
  dispatch(setLoading({ key: "isLoadingCredit", value: true }));
  try {
    const response = await getUserCreditApi(userSub);
    const creditData = response.data.data;
    dispatch(setUserCredit(Array.isArray(creditData) ? creditData[0] || null : creditData));
  } catch (error) {
    dispatch(setError(error.response?.data?.message || "Failed to fetch credit"));
    dispatch(setLoading({ key: "isLoadingCredit", value: false }));
  }
};


export const performCreditTransfer = (data) => async (dispatch) => {
  dispatch(setTransferring(true));
  try {
    const response = await submitCreditTransferApi(data);
    dispatch(setTransferResult({ success: true, data: response.data }));
    return { success: true };
  } catch (error) {
    const message = error.response?.data?.message || "Credit transfer failed";
    dispatch(setTransferResult({ success: false, message }));
    return { success: false, message };
  }
};
